import { Tab, Tabs } from '@mui/material';
import { AppConfig } from 'AppConfig';
import { fetchData } from 'features/user/userActions';
import * as UserTypes from 'features/user/userTypes';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, Outlet, useLocation } from 'react-router-dom';
import routePaths from 'routes/routePaths';
import { tabNoUnderlineSx, tabsNoUnderlineSx } from 'common/tabSx';
import { store } from 'store/store';

const ClientPortalNavigator = () => {
  const CLIENT_PORTAL_DASHBOARD_URL = routePaths.clientPortal;
  const CLIENT_PORTAL_ANNUALPLANRENEWAL_URL = CLIENT_PORTAL_DASHBOARD_URL + AppConfig.CLIENT_PORTAL_SUB_URL.ANNUAL_PLAN_RENEWAL;

  const location = useLocation();
  const { currentTenantCd } = useSelector((state) => state.user);

  useEffect(() => {
    const timeout = setTimeout(() => {
      store.dispatch(fetchData(currentTenantCd, AppConfig.APP_CODE_CLIENT_PORTAL, { explicitTenant: false }));
      store.dispatch({
        type: UserTypes.APP_SWITCHED,
        payload: AppConfig.HEADER_MENU_TYPE.STANDARD
      });
    }, 1000);
    return () => clearTimeout(timeout);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Tabs
        value={location.pathname}
        indicatorColor="primary"
        textColor="primary"
        sx={tabsNoUnderlineSx}>
        <Tab
          label={AppConfig.CLIENT_PORTAL_SUBCATEGORY.ANNUAL_PLAN_RENEWAL}
          value={CLIENT_PORTAL_ANNUALPLANRENEWAL_URL}
          component={Link}
          to={CLIENT_PORTAL_ANNUALPLANRENEWAL_URL}
          sx={tabNoUnderlineSx}
        />
      </Tabs>
      <Outlet />
    </>
  );
};

export default ClientPortalNavigator;
